<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<script>
import { i18n } from '../i18n.js';
import { SUPPORTED_LANGUAGES } from '../i18n.js';

let activeLanguage = i18n.language;

function changeLanguage(event) {
  const newLang = event.target.value;
  localStorage.setItem('language', newLang);
  i18n.changeLanguage(newLang);
  activeLanguage = newLang;
}
</script>

<div class="lang-switcher-dropdown">
  <select bind:value={activeLanguage} on:change={changeLanguage}>
    {#each SUPPORTED_LANGUAGES as lang (lang.code)}
      <option value={lang.code}>{lang.name}</option>
    {/each}
  </select>
</div>

<style>
  .lang-switcher-dropdown {
    position: fixed;
    top: 95px;
    right: 13px;
    z-index: 1;
  }
  .lang-switcher-dropdown select {
    padding: 8px 12px;
    border-radius: 5px;
    border: 1px solid black;
    background: white;
    font-weight: bold;
    cursor: pointer;
  }

  @media screen and (max-width: 640px) {
    .lang-switcher-dropdown {
      display: none;
    }
  }
</style>